import {
  Award,
  BookOpen,
  Calculator,
  CalendarClock,
  ChartArea,
  Dot,
  FileSearch,
  FileText,
  FolderKey,
  FolderOpen,
  Gauge,
  LayoutDashboard,
  ListChecks,
  ListOrdered,
  PieChart,
  Receipt,
  ReceiptText,
  ShieldCheck,
  Timer,
  Truck,
  UsersRound,
  Vault,
} from 'lucide-react'

import { TrailerIcon } from '../icons/TrailerIcon'
import type { SidebarIcon } from './model'

/** Keyed by the icon names the sidebar services send. */
const ICONS: Record<string, SidebarIcon> = {
  award: Award,
  'book-open': BookOpen,
  calculator: Calculator,
  'calendar-clock': CalendarClock,
  'chart-area': ChartArea,
  dot: Dot,
  'file-search': FileSearch,
  'file-text': FileText,
  'folder-key': FolderKey,
  'folder-open': FolderOpen,
  gauge: Gauge,
  'layout-dashboard': LayoutDashboard,
  'list-checks': ListChecks,
  'list-ordered': ListOrdered,
  'pie-chart': PieChart,
  receipt: Receipt,
  'receipt-text': ReceiptText,
  'shield-check': ShieldCheck,
  timer: Timer,
  trailer: TrailerIcon,
  truck: Truck,
  'users-round': UsersRound,
  vault: Vault,
}

/** An unknown name draws a dot rather than an empty slot. */
export function sidebarIcon(name: string): SidebarIcon {
  return ICONS[name] ?? Dot
}
